type StoredItemKey = 'accessLevel' | 'accessToken' | 'products' | 'profile';

export const _storeLocalStorageItem = ({
	storageKey,
	storageValue,
}: {
	storageKey: StoredItemKey;
	storageValue: string;
}) => {
	try {
		localStorage.setItem(storageKey, storageValue);
	} catch (error) {
		return error;
	}
};

export const _retrieveLocalStorageItem = (storageKey: StoredItemKey) => {
	try {
		const value = localStorage.getItem(storageKey);
		if (value !== null) {
			return value;
		}
	} catch (error) {
		return error;
	}
};

export const _removeLocalStorageItem = (storageKey: StoredItemKey) => {
	try {
		localStorage.removeItem(storageKey);
	} catch (error) {
		return error;
	}
};
